import React from 'react';
import { useAuth } from '../auth/AuthContext';
import Navbar from './Navbar';
import ConfigurationDemo from '../configuration/ConfigurationDemo';
import InstallationGuide from './InstallationGuide';
import FeatureGrid from '../features/FeatureGrid';
import InstallationStats from '../analytics/InstallationStats';
import { AdSpotterWidget } from '../../AdSpotterWidget';
import type { ButtonCustomization } from '../../lib/types';

const Dashboard = () => {
  const { user, isAdmin } = useAuth();
  const [buttonConfig, setButtonConfig] = React.useState<ButtonCustomization>({
    text: 'Partner with Us',
    backgroundColor: '#FFFFFF',
    textColor: '#000000',
    showIcon: false,
    position: 'bottom-right',
    fontSize: '0.875rem',
    padding: '0.75rem 1.5rem',
    borderRadius: '0.25rem',
    borderColor: '#E5E7EB',
  });

  if (!user) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="space-y-8">
          {isAdmin && <InstallationStats />}
          <ConfigurationDemo onConfigChange={setButtonConfig} />
          <InstallationGuide buttonConfig={buttonConfig} />
          <FeatureGrid />
          <AdSpotterWidget buttonStyle={buttonConfig} />
        </div>
      </main>
    </div>
  );
};

export default Dashboard;